export const CREATE_PROJECT_TEAM_MEMBER_ATTEMPT = 'CREATE_PROJECT_TEAM_MEMBER_ATTEMPT';
export type CREATE_PROJECT_TEAM_MEMBER_ATTEMPT = typeof CREATE_PROJECT_TEAM_MEMBER_ATTEMPT;

export const CREATE_PROJECT_TEAM_MEMBER_SUCCESS = 'CREATE_PROJECT_TEAM_MEMBER_SUCCESS';
export type CREATE_PROJECT_TEAM_MEMBER_SUCCESS = typeof CREATE_PROJECT_TEAM_MEMBER_SUCCESS;

export const CREATE_PROJECT_TEAM_MEMBER_FAILURE = 'CREATE_PROJECT_TEAM_MEMBER_FAILURE';
export type CREATE_PROJECT_TEAM_MEMBER_FAILURE = typeof CREATE_PROJECT_TEAM_MEMBER_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/team-member/create/Types.tsx